export default {
  title: 'Wishlist',

  // vue-i18n plural (en rule): one | other
  savedCount: '{count} game saved | {count} games saved',
  clearAll: 'Clear all',
  cleared: 'Removed {count} game from wishlist | Removed {count} games from wishlist',

  sort: {
    aria: 'Sort by',
    recent: 'Recently added',
    oldest: 'Oldest first',
    name: 'Name A–Z',
    priceAsc: 'Price ↑',
    priceDesc: 'Price ↓',
  },

  empty: {
    title: 'No favorites yet',
    body: 'Tap the heart on any game to save it for later and track price drops.',
    cta: 'Browse catalog',
  },
};
